import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/vasteras")(
  heritageCityRoute({
    citySlug: "vasteras",
    angle:
      "Västerås är ett av Fennys kontorsorter, och här arbetar vi nära både industriföretag med djup teknisk erfarenhet och familjer i Mälardalen som vill dokumentera en närståendes berättelse.",
    localUseCases: [
      "Filmad livsberättelse hemma i Västerås och Mälardalen",
      "Kunskapsöverföring i industri- och energibolag",
      "Dokumentation av tyst kunskap i produktion",
      "Grundar- och företagshistoria inför jubileum",
      "Generationsskifte i ägarledda Mälardalsbolag",
      "Minnesfilm till 80- och 90-årsdagar"
    ],
  }),
);
